import React from "react";
import { Container, Row, Col, Card, Image } from "react-bootstrap";

// Images
import avatar1 from "assets/images/users/avatar-1.jpg";
import avatar2 from "assets/images/users/avatar-2.jpg";
import avatar3 from "assets/images/users/avatar-3.jpg";
import avatar4 from "assets/images/users/avatar-4.jpg";
import avatar5 from "assets/images/users/avatar-5.jpg";
import withRouter from "Common/withRouter";

// Logo
import Rnetlogo from "../../assets/logo/R-Nets-N-knots-logo.png";

const ParticlesAuth = ({ children }: any) => {
  return (
    <React.Fragment>
      <div className="auth-page-wrapper py-5 position-relative d-flex align-items-center justify-content-center min-vh-100">
        <Container>
          <Row className="justify-content-center">
            <Col lg={11}>
              <Card className="mb-0">
                <Row className="g-0 align-items-center">
                  {/* Left side */}
                  <Col xxl={5} className="d-none d-xxl-block">
                    <Card className="auth-card bg-secondary h-100 border-0 shadow-none mb-0">
                      <Card.Body className="py-5 d-flex justify-content-between flex-column">
                        {/* <div className="text-center">
                          <h3 className="text-white">Start your journey with us.</h3>
                          <p className="text-white opacity-75 fs-base">
                            It brings together your tasks, projects, timelines, files and more
                          </p>
                        </div> */}

                        <div className="auth-effect-main my-5 position-relative rounded-circle d-flex align-items-center justify-content-center mx-auto">
                          <div className="effect-circle-1 position-relative mx-auto rounded-circle d-flex align-items-center justify-content-center">
                            <div className="effect-circle-2 position-relative mx-auto rounded-circle d-flex align-items-center justify-content-center">
                              <div className="effect-circle-3 mx-auto rounded-circle position-relative text-white fs-4xl d-flex align-items-center justify-content-center">
                                {/* Welcome 👋 */}
                                {/* <span className="text-primary ms-1">Steex</span> */}
                                {/* <h4 style={{fontWeight:500 ,whiteSpace:"10px" , letterSpacing:1}} className="text-white">Welcome To Inventory And Asset Management Dashboard 👋</h4> */}

                                <div className="text-center">
                                  <div className="w-100 mx-auto">
                                    <img
                                      src={Rnetlogo}
                                      alt="Rnet Logo"
                                      className="img-fluid"
                                    />
                                  </div>
                                </div>

                                {/* <p className="text-white opacity-75 fs-base">
                            It brings together your tasks, projects, timelines, files and more
                          </p> */}
                              </div>
                            </div>
                          </div>
                          {/* <ul className="auth-user-list list-unstyled">
                            {[avatar1, avatar2, avatar3, avatar4, avatar5].map((img, idx) => (
                              <li key={idx}>
                                <div className="avatar-sm d-inline-block">
                                  <div className="avatar-title bg-white shadow-lg overflow-hidden rounded-circle">
                                    <Image src={img} alt="" className="img-fluid" />
                                  </div>
                                </div>
                              </li>
                            ))}
                          </ul> */}
                        </div>

                        <div className="text-center">
                          <p className="text-white opacity-75 mb-0 mt-3">
                            &copy; Copyright {new Date().getFullYear()}
                          </p>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  {/* Right side - login form */}
                  <Col
                    xs={12}
                    xxl={7}
                    className="d-flex flex-column align-items-center justify-content-start position-relative"
                  >
                    <div
                      className="d-block d-xxl-none text-center"
                      style={{ marginTop: "70px" }}
                    >
                      <img
                        src={Rnetlogo}
                        alt="Rnet Logo Small"
                        className="img-fluid"
                        style={{ maxWidth: "220px" }}
                      />
                    </div>
                    {children}
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ParticlesAuth);
